import React, { useState, useEffect } from "react";
import { GetIntegrationDocument } from "../../../api/Api";
import "./integrationDocument.css";

const IntegrationDocument = () => {
    const [integrationDocument, setIntegrationDocument] = useState([]);

    const getAllData = async () => {
        const response = await GetIntegrationDocument();
        if (response?.statusDescription?.status === 200) {
            setIntegrationDocument(response?.documentList || []);
        }
    };

    useEffect(() => {
        getAllData();
    }, []);

    const handleDocumentClick = (documentLink) => {
        window.open(documentLink, '_blank');
    };


    return (
        <div className="content-wrapper">
            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="box">
                            <div className="box-header">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb_bg">
                                        <li className="breadcrumb-item">
                                            <a className="breadcrumb_1">Document</a>
                                        </li>
                                        <li className="breadcrumb-item active breadcrumb_2">
                                            Integration Document
                                        </li>
                                    </ol>
                                </nav>
                            </div>

                            <div className="box-body">
                                <div className="document-grid">
                                    {integrationDocument.map((doc) => (
                                        <div key={doc.id} className="document-card" onClick={() => handleDocumentClick(doc.documentLink)}>
                                            <div className="document-icon">
                                                <i className="fas fa-file-pdf"></i>
                                            </div>
                                            <div className="document-name">
                                                {doc.documentName}
                                            </div>
                                            <div className="download-icon">
                                                <i className="fas fa-download"></i>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default IntegrationDocument;